export const STATES_VALUE = {
	invalid: 'InValid',
	waiting: 'Waiting',
	valid: 'Valid',
};

export const STATES_REQUEST_VALUE = {
	confirmed: 'Confirmed',
	waiting: 'Waiting',
	cancelled: 'Cancelled',
};

export const STATES = {
	[STATES_REQUEST_VALUE.cancelled]: {
		label: 'عدم تایید',
		value: STATES_REQUEST_VALUE.cancelled,
	},
	[STATES_REQUEST_VALUE.confirmed]: {
		label: 'تایید شده',
		value: STATES_REQUEST_VALUE.confirmed,
	},
	[STATES_REQUEST_VALUE.waiting]: {
		label: 'در انتظار تایید',
		value: STATES_REQUEST_VALUE.waiting,
	},
};

export const getState = (state) => {
	return STATES[state];
};

export const TRANSACTION_STATES = {
	[-1]: {
		label: 'ایجاد شده',
		value: -1,
	},
	0: {
		label: 'در انتظار تایید',
		value: 0,
	},
	1: {
		label: 'تایید شده',
		value: 1,
	},
	2: {
		label: 'لغو شده',
		value: 2,
	},
};
export const getTransactionState = (state) => {
	return TRANSACTION_STATES[+state];
};

// 0: {
// 	label: 'برداشت',
// 		value: 0,
// },
// 1: {
// 	label: 'شارژ',
// 		value: 1,
// },
// 2: {
// 	label: 'رزرو وقت توسط کسب‌وکار',
// 		value: 2,
// },
// 3: {
// 	label: 'رزرو وقت توسط مشتری',
// 		value: 3,
// },
// 4: {
// 	label: 'پلن پیامکی',
// 		value: 4,
// },
// 5: {
// 	label: 'عدم تایید توسط کسب‌وکار',
// 		value: 5,
// },

export const TRANSACTION_TYPE = {
	0: {
		label: 'برداشت',
		value: 0,
	},
	1: {
		label: 'شارژ',
		value: 1,
	},
	2: {
		label: 'رزرو وقت',
		value: 2,
	},
	3: {
		label: 'رزرو وقت توسط مشتری',
		value: 3,
	},
	4: {
		label: 'پلن پیامکی',
		value: 4,
	},
	5: {
		label: 'عدم تایید رزرو',
		value: 5,
	},
};

export const getTransactionType = (type) => {
	return TRANSACTION_TYPE[+type];
};

// state:
// public enum TransactionState
// {
//     Created = -1,
//     Waiting = 0,
//     Confirmed = 1,
//     Cancelled = 2
// }

// type:
// public enum TransactionType
// {
//     Withdraw = 0,
//     Charge = 1,
//     ReserveTimeSender = 2,
//     ReserveTimeReceipt = 3,
//     SmsPlan = 4
// }
